import React, { useState } from "react";

import line from "../assets/images/line.png";
import logo from "../assets/images/logo.png";
import forSeller from "../assets/images/for-seller.png";
import forBuyer from "../assets/images/for-buyer.png";
import forGifter from "../assets/images/for-gifter.png";
import mediaPlayer from "../assets/images/media-player.png";
import mediaPlayerTilted from "../assets/images/media-player-tilted.png";

const ComingSoon = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formValues, setFormValues] = useState({
    name: "",
    email: "",
    interestedAs: "",
  });

  const openModal = (interestedAs) => {
    setFormValues((prev) => ({
      ...prev,
      interestedAs,
    }));
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsModalOpen(false);
  };

  return (
    <div className="coming-soon-page position-relative">
      <img
        src={line}
        alt="Construction warning stripe"
        className="coming-soon-top-line"
      />

      <div className="coming-soon-main">
        <img src={logo} alt="Bazarna" className="coming-soon-logo" />

        <p className="coming-soon-tagline">
          A community-driven marketplace app empowering people across <br /> the
          UAE to buy, sell, and gift with ease.
        </p>

        <button className="coming-soon-button mb-5">Launching Soon</button>

        <div className="coming-soon-cards">
          <div
            className="coming-soon-card coming-soon-card--sellers"
            onClick={() => openModal("Seller")}
          >
            <img
              src={forSeller}
              alt="For sellers"
              className="coming-soon-card-image"
            />
            <div className="coming-soon-card-overlay" />
            {/* <div className="coming-soon-card-label">
              For Sellers
            </div> */}
            <div className="coming-soon-card-hover coming-soon-card-hover--sellers">
              <h3 className="coming-soon-card-hover-title">For Sellers</h3>
              <p className="coming-soon-card-hover-text">
                Kickstart your home-grown business or sell personal items
                effortlessly — start selling on the app in just a few clicks.
              </p>
            </div>
          </div>

          <div
            className="coming-soon-card coming-soon-card--buyers"
            onClick={() => openModal("Buyer")}
          >
            <img
              src={forBuyer}
              alt="For buyers"
              className="coming-soon-card-image"
            />
            <div className="coming-soon-card-overlay" />
            {/* <div className="coming-soon-card-label">
              For Buyers
            </div> */}
            <div className="coming-soon-card-hover coming-soon-card-hover--buyers">
              <h3 className="coming-soon-card-hover-title">For Buyers</h3>
              <p className="coming-soon-card-hover-text">
                Discover quality products crafted by owners themselves, where
                care & craftsmanship matter more than inflated brand margins.
              </p>
            </div>
          </div>

          <div
            className="coming-soon-card coming-soon-card--gifters"
            onClick={() => openModal("Gifter")}
          >
            <img
              src={forGifter}
              alt="For gifters"
              className="coming-soon-card-image"
            />
            <div className="coming-soon-card-overlay" />
            {/* <div className="coming-soon-card-label">
              For Gifters
            </div> */}
            <div className="coming-soon-card-hover coming-soon-card-hover--gifters">
              <h3 className="coming-soon-card-hover-title">For Gifters</h3>
              <p className="coming-soon-card-hover-text">
                Gift extra items from your home to your community — turning what
                you don&apos;t need into essentials for others.
              </p>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <div className="coming-soon-modal-backdrop">
            <div className="coming-soon-modal">
              <button
                type="button"
                className="coming-soon-modal-close"
                onClick={closeModal}
              >
                ×
              </button>

              <h2 className="coming-soon-modal-title">
                Share your details to be the first to know <br /> when we&apos;re live
              </h2>

              <form className="coming-soon-modal-form" onSubmit={handleSubmit}>
                <div className="coming-soon-modal-row">
                  <input
                    type="text"
                    name="name"
                    value={formValues.name}
                    onChange={handleChange}
                    className="coming-soon-modal-input"
                    placeholder="Full Name"
                  />
                  <input
                    type="email"
                    name="email"
                    value={formValues.email}
                    onChange={handleChange}
                    className="coming-soon-modal-input"
                    placeholder="Email"
                  />
                </div>

                <div className="coming-soon-modal-row">
                  <input
                    type="text"
                    name="interestedAs"
                    value={formValues.interestedAs}
                    onChange={handleChange}
                    className="coming-soon-modal-input"
                    placeholder="Interested as"
                  />
                  <button type="submit" className="coming-soon-modal-submit">
                    Notify Me
                  </button>
                </div>
              </form>
              <div className="coming-soon-modal-footer">
                We respect your privacy. No spam.
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="coming-soon-hero-row">
        <img
          src={mediaPlayer}
          alt="Construction cone"
          className="coming-soon-side-image coming-soon-side-image-left"
        />

        <img
          src={mediaPlayerTilted}
          alt="Construction cone tilted"
          className="coming-soon-side-image coming-soon-side-image-right"
        />
      </div>
    </div>
  );
};

export default ComingSoon;
